import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "me-4" }
const _hoisted_4 = { class: "me-4" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "border p-3 d-flex rounded mt-3" }
const _hoisted_11 = { class: "flex-grow-1 ps-4 pe-4" }
const _hoisted_12 = {
  key: 0,
  class: "invalid-feedback d-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSlider = _resolveComponent("VueSlider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "option",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
            value: _ctx.Option.Number,
            class: "me-1"
          }, null, 8, _hoisted_5), [
            [_vModelRadio, _ctx.input]
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('form.labels.exactNumber')), 1)
        ]),
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "option",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input) = $event)),
            value: _ctx.Option.Range,
            class: "me-1"
          }, null, 8, _hoisted_6), [
            [_vModelRadio, _ctx.input]
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('form.labels.numberRange')), 1)
        ])
      ]),
      (_ctx.input === _ctx.Option.Number)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.numberValueRaw) = $event)),
              type: "number",
              class: "form-control"
            }, null, 512), [
              [_vModelText, _ctx.numberValueRaw]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.input === _ctx.Option.Range)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.minRaw) = $event)),
                type: "number",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.minRaw]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ms-2 me-2" }, "-", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.maxRaw) = $event)),
                type: "number",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.maxRaw]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", null, _toDisplayString(_ctx.bounds[0]), 1),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.input === _ctx.Option.Number)
          ? (_openBlock(), _createBlock(_component_VueSlider, {
              key: 0,
              min: _ctx.bounds[0],
              max: _ctx.bounds[1],
              modelValue: _ctx.normalize(_ctx.numberValue),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.numberValueRaw = $event))
            }, null, 8, ["min", "max", "modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.input === _ctx.Option.Range)
          ? (_openBlock(), _createBlock(_component_VueSlider, {
              key: 1,
              min: _ctx.bounds[0],
              max: _ctx.bounds[1],
              modelValue: [_ctx.normalize(_ctx.min), _ctx.normalize(_ctx.max)],
              onChange: _ctx.updateRangeSlider
            }, null, 8, ["min", "max", "modelValue", "onChange"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.bounds[1]), 1)
    ]),
    (_ctx.isInvalid())
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (! _ctx.isValueInBounds())
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('form.errors.notANumber')), 1)
              ], 64))
            : (_ctx.getValue() === null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('form.errors.parameterNotFilled', [_ctx.label])), 1)
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}